import { defineComponent as u, openBlock as o, createElementBlock as a, mergeProps as h, unref as e, renderSlot as i, createElementVNode as l, createCommentVNode as V } from "vue";
import { useScalarIcon as H } from "../hooks/useScalarIcon.js";
const v = { key: 0 }, g = { key: 1 }, m = { key: 2 }, f = { key: 3 }, A = { key: 4 }, k = { key: 5 }, M = {
  name: "ScalarIconPlus"
}, y = /* @__PURE__ */ u({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: d, weight: n } = H(r);
    return (p, t) => (o(), a("svg", h({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      i(p.$slots, "default"),
      e(n) === "bold" ? (o(), a("g", v, t[0] || (t[0] = [
        l("path", { d: "M228,128a12,12,0,0,1-12,12H140v76a12,12,0,0,1-24,0V140H40a12,12,0,0,1,0-24h76V40a12,12,0,0,1,24,0v76h76A12,12,0,0,1,228,128Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (o(), a("g", g, t[1] || (t[1] = [
        l("path", {
          d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : e(n) === "fill" ? (o(), a("g", m, t[2] || (t[2] = [
        l("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM184,136H136v48a8,8,0,0,1-16,0V136H72a8,8,0,0,1,0-16h48V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : e(n) === "light" ? (o(), a("g", f, t[3] || (t[3] = [
        l("path", { d: "M222,128a6,6,0,0,1-6,6H134v82a6,6,0,0,1-12,0V134H40a6,6,0,0,1,0-12h82V40a6,6,0,0,1,12,0v82h82A6,6,0,0,1,222,128Z" }, null, -1)
      ]))) : e(n) === "regular" ? (o(), a("g", A, t[4] || (t[4] = [
        l("path", { d: "M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : e(n) === "thin" ? (o(), a("g", k, t[5] || (t[5] = [
        l("path", { d: "M220,128a4,4,0,0,1-4,4H132v84a4,4,0,0,1-8,0V132H40a4,4,0,0,1,0-8h84V40a4,4,0,0,1,8,0v84h84A4,4,0,0,1,220,128Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  y as default
};
